<div style="width: 100%; align-items: center">
  @if (loadingData()) {
    <mat-progress-spinner mode="indeterminate" style="margin: 0 auto; margin-top: 20px"></mat-progress-spinner>
  }
</div>
@let details = transactionDetails();
@if (details) {
  <app-transaction-details
    (misidentifiedFace)="handleMisidentifiedFace($event)"
    (theftCategoryChange)="handleTheftCategoryChange($event)"
    (newComment)="handleNewComment()"
    mode="normal"
    [cancellationId]="cancellationId"
    [isTheft]="isTheft()"
    [transactionDetails]="details"
    [lastSeen]="lastSeen"
    [hasComments]="hasComments()"
    [hasVideo]="hasVideo"
  ></app-transaction-details>
}
